module.exports = {
  "wrapper-ipx": {
    "height": "68",
    "borderTopWidth": "1",
    "borderTopStyle": "solid"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-5a9876d8!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-ipx-bar/index.vue
// module id = 494
// module chunks = 0 1